module.exports = __webpack_public_path__ + "static/media/error_filled_red.49a05b49.svg";